import { render } from "./FiltraContrattiPage.vue?vue&type=template&id=7fdc6c7c"
import script from "./FiltraContrattiPage.vue?vue&type=script&lang=js"
export * from "./FiltraContrattiPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/spark/spark-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__